export const STORAGE_KEY = 'sanitas-'

// ---- SESSION start ----
export const SESSION_GROUP = {
  LEAD: 'lead',
}
// ---- SESSION end ----

export const APP = {
  NAME: 'pet',
  VERSION: '1.0.0',
  PET: {
    env: import.meta.env.VITE_APP_PET_ENV,
    name: 'pet',
    group: SESSION_GROUP.LEAD,
  },
}

export const SUPPORTED_LANGUAGES = [
  { text: 'DE', value: 'DE' },
  { text: 'FR', value: 'FR' },
  { text: 'IT', value: 'IT' },
  { text: 'EN', value: 'EN' },
]

export const DATE_FORMAT_DIN = 'dd.MM.yyyy'
export const DATE_FORMAT_ISO = 'yyyy-MM-dd'

export const DEFAULT_LANGUAGE = 'EN'
export const DEFAULT_TIME = 1000 // 1 sec in milliseconds
export const DEFAULT_DELAY_TIME = DEFAULT_TIME / 2
export const DEFAULT_FORM_DEBOUNCE_TIME = 200

export const NOTIFICATION = {
  LIFETIME: DEFAULT_TIME * 10,
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success',
}

export const PACKAGE = {
  BASIC: 'basic',
  ERRORS: 'errors',
  CONTENT: 'content',
  pet: 'pet',
}

export const TIPPY_THEME = {
  pet: 'pet',
}

export const SESSION_EOL = { days: 2 }

// ---------- focus start ---------
export const DEFAULT_FOCUS_DELAY = 501 // needs to be bigger than the transition duration
export const ON_SCREEN_FOCUS_DELAY = 175
// ---------- focus end ---------

// ---------- FORMS start ---------
export const FOCUSABLE_INPUT_QUERY =
  'input:not([readonly]), textarea:not([readonly]), .select__trigger, .tile, .segment'
// ---------- FORMS end ---------

// ---- custom api errors start -----
export const API_ERROR = {
  CATASTROPHICAL_ERROR: 'CATASTROPHICAL_ERROR',
  INFRASTRUCTURE_ERROR: 'INFRASTRUCTURE_ERROR',
}
// ---- custom api errors end -----

// ---- sales partner flow types start -----
export const FLOW_TYPE = {
  CUSTOMER_FLOW: 'CUSTOMER_FLOW',
  EMPLOYEE_FLOW: 'EMPLOYEE_FLOW',
  EMPLOYEE_FLOW_UNLICENSED_ERROR: 'EMPLOYEE_FLOW_UNLICENSED_ERROR'
}
export const CUSTOMER_FLOW_SALES_PARTNER_NUMBER = '374940'
// ---- sales partner flow types end -----

// ---- survey start -----
export const SURVEY_TOUCHPOINT_DOGS = 'PETD'
export const SURVEY_TOUCHPOINT_CATS = 'PETC'
// ---- survey end -----
